<template>
  <div class="flex flex-grow justify-center items-center flex-col">
    <div class="max-w-400 w-full mx-auto">
      <h2 class="text-4xl font-medium text-black-900 mb-3">Forgot password</h2>
      <p class="text-black-900 text-base mb-8 pr-20">
        Enter the email address you used when you joined and we’ll send you
        instructions to reset your password.
      </p>
      <validation-observer
        tag="form"
        ref="form"
        @submit.prevent="handleSubmit"
        class="space-y-6 mb-11"
      >
        <utils-input
          :validationRules="'required|email'"
          :inputName="'Email'"
          :inputType="'text'"
          :isSubmitted="isSubmitted"
        />

        <base-button colorScheme="orange" class="mt-8 py-3 w-full">
          <span class="font-normal text-sm"> Reset password</span>
        </base-button>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";

import BaseButton from "@/components/utils/Button.vue";
import UtilsInput from "@/components/utils/UtilsInput.vue";

export default {
  name: "AuthForgotPasswordForm",
  components: {
    "utils-input": UtilsInput,
    "base-button": BaseButton,
    ValidationObserver,
  },
  data() {
    return {
      isSubmitted: false,
    };
  },
  methods: {
    handleSubmit() {
      this.isSubmitted = true;

      this.$refs.form.validate().then((valid) => {
        if (!valid) {
          return;
        }

        console.log("Form submitted");
      });
    },
  },
};
</script>
